import React from 'react';

interface DataRowProps {
    value: string | number;
    label?: string;
    specificValue?: string;
    isSpecificVoltageCase?: boolean;
    unit?: string | JSX.Element;
}

const DataRow = ({ label, value, specificValue, isSpecificVoltageCase, unit }: DataRowProps) => (
    <div className='data-row'>
        <div className='data-label'>
            {label}
        </div>
        <div className={`data-cell ${specificValue || isSpecificVoltageCase ? '' : 'full-width'}`}>
            <div className='data-value'>{value}</div>
            <div className='data-unit'>{unit}</div>            
        </div>
        {specificValue &&
            <div className='data-cell'>
                {specificValue}
            </div>
        }
    </div>
);

export default DataRow;
